import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute, RequireAuth, Splash } from "@/components/ProtectedRoute";

import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import ChangePassword from "@/pages/ChangePassword";
import AdminLayout from "@/components/AdminLayout";
import EmployeeLayout from "@/components/EmployeeLayout";

import AdminDashboard from "@/pages/admin/Dashboard";
import CompanySettings from "@/pages/admin/Settings";
import Designations from "@/pages/admin/Designations";
import Employees from "@/pages/admin/Employees";
import EmployeeDetail from "@/pages/admin/EmployeeDetail";
import Holidays from "@/pages/admin/Holidays";
import Payroll from "@/pages/admin/Payroll";
import Audit from "@/pages/admin/Audit";

import EmployeeDashboard from "@/pages/employee/Dashboard";
import EmployeePayslips from "@/pages/employee/Payslips";
import EmployeeProfile from "@/pages/employee/Profile";

function RootRedirect() {
  const { user } = useAuth();
  if (user === undefined) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/setup" element={<Setup />} />
            <Route path="/change-password" element={<RequireAuth><ChangePassword /></RequireAuth>} />

            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="payroll" element={<Payroll />} />
              <Route path="employees" element={<Employees />} />
              <Route path="employees/:id" element={<EmployeeDetail />} />
              <Route path="designations" element={<Designations />} />
              <Route path="holidays" element={<Holidays />} />
              <Route path="settings" element={<CompanySettings />} />
              <Route path="audit" element={<Audit />} />
            </Route>

            <Route path="/portal" element={<ProtectedRoute role="employee"><EmployeeLayout /></ProtectedRoute>}>
              <Route index element={<EmployeeDashboard />} />
              <Route path="payslips" element={<EmployeePayslips />} />
              <Route path="profile" element={<EmployeeProfile />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
